import { object, string } from 'yup';

export const getExaminationValidationSchema = (t) =>
	object().shape({
		name: string().required(t('EXAMINATIONS.VALIDATION.NAME_REQUIRED')),
		status: string().required(t('EXAMINATIONS.VALIDATION.STATUS_REQUIRED')),
	});